var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMilestoneKite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.1213 50.8787C26.9497 52.0503 25.0503 52.0503 23.8787 50.8787L1.12132 28.1213C-0.0502533 26.9498 -0.0502535 25.0503 1.12132 23.8787L23.8787 1.12133C25.0502 -0.0502486 26.9497 -0.0502487 28.1213 1.12132L50.8787 23.8787C52.0502 25.0503 52.0503 26.9497 50.8787 28.1213L28.1213 50.8787Z",
    fill: "#2B2B32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMilestoneKite);
export default __webpack_public_path__ + "static/media/MilestoneKite.f32e7ae7.svg";
export { ForwardRef as ReactComponent };